// Detect dev mode - check __DEV__ first, then fall back to NODE_ENV
// const shouldUseLocalBackend =
//   typeof __DEV__ !== "undefined"
//     ? __DEV__
//     : (typeof process !== "undefined" && process.env && process.env.NODE_ENV === "development");
// Uncomment this line (and comment the above) to use the production backend in dev.
const shouldUseLocalBackend = false;

module.exports = {
  sentryDSN:
    "https://7a9cba7e96b54da4bae2c6eb9b8d7b18@o240663.ingest.sentry.io/5306223",
  sentryOrg: "andy-matuschak",
  sentryProject: "orbit-app",
  // Store your auth token securely: firebase functions:config:set sentry.auth_token=SENTRY_AUTH_TOKEN

  httpsAPIBaseURLString: shouldUseLocalBackend
    ? "http://127.0.0.1:5001/fahm-8cea6/us-central1/api"
    : "https://us-central1-fahm-8cea6.cloudfunctions.net/api",
  shouldUseLocalBackend,

  appleDevelopmentTeamID: "MQ22N839N8",
};
